import React,{Component} from 'react';
import axios from 'axios';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import {userSessionManage} from '../../../service/userLocalStorage';
import validator from 'validator';
import 'react-confirm-alert/src/react-confirm-alert.css';

let _loader = 'glb-ldr-prt active';
let vsSession = localStorage.getItem('vs_UserSession');
let _adminId = '0';
let _loginName = '';
let _loginEmail = '';
let _profileLogo = '';
let _loginType = 'Business';
let _owner_name = '';
let _owner_email = '';
let _owner_country_code = '';
let _owner_contact = '';
let _business_address = '';
if(vsSession!=undefined || vsSession!=null)
{
    vsSession = JSON.parse(vsSession);
    
    _adminId = (vsSession.loginId > 0) ? vsSession.loginId : '0';
    _loginName = vsSession.loginName ? vsSession.loginName : 'Business Admin / User';
    _loginEmail = vsSession.loginEmail ? vsSession.loginEmail : 'admin@vyavsay.com';
    _profileLogo = vsSession ? vsSession.profile_logo : '';
    _loginType = vsSession.loginType ? vsSession.loginType : 'Business';
    _owner_name = vsSession.owner_name ? vsSession.owner_name : '';
    _owner_email = vsSession.owner_email ? vsSession.owner_email : '';
    _owner_country_code = vsSession.owner_country_code ? vsSession.owner_country_code : '';
    _owner_contact = vsSession.owner_contact ? vsSession.owner_contact : '';
    _business_address = vsSession.business_address ? vsSession.business_address : '';
    
}

export default class profilePanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            buttonTitle:'Update Profile',
            isLoaded : true,
            loginName : _loginName,
            loginEmail : _loginEmail,
            loginType : _loginType,
            ownerName : _owner_name,
            ownerEmail : _owner_email,
            ownerContact : _owner_contact,
            ownerCountryCode : _owner_country_code,
            ownerBussAddress:_business_address,
            logo : '',
            profileLogo : _profileLogo || '',
            previewUrl : '',
            avatarBroken : false,
            uploadingPic : false,
            uploadProgress : 0,
            isDraggingFile : false,
            isAvatarHover : false,
            currentPassword : '',
            newPassword : '',
            confirmPassword : '',
            
            _countryLang:'',
            _countryReg:'iti__hide',
            _countryReg_O:'iti__hide',
            _countryFlag:'',
            _countryName:'',
            _countryPh:'',
            _countryId:'0',
            countryArray : [],

            errors: {
                loginName : '',
                loginEmail : '',
                loginType : '',
                ownerName : '',
                ownerEmail : '',
                ownerContact : '',
                ownerCountryCode : '',
                ownerBussAddress : '',
            },
            errorsPassword: {
                currentPassword : '',
                newPassword : '',
                confirmPassword : ''
            }
        }
    }

    async componentDidMount ()
    {
        let _countryCode = 'IN';
        
        //'http://api.hostip.info'
        //'https://ipinfo.io/'
        PostData('http://ip-api.com/json','','GET').then(response => {
            let responseJson = response;
            _countryCode = responseJson.countryCode;
            userSessionManage(localStorage,responseJson,'countrySession');
        })
        .catch(error => this.setState({ error, isLoaded: false }));
        
        let _urlCountryData = global.adminCountryList;
        let countryData = await PostData(_urlCountryData,'','GET');
        let _conLang,_conFlag,_conName,_conPh,_conId = '';
        countryData.response.map((conty, i) =>{
            let _name = conty.sortname.toLowerCase();
            let _imgPath = global.FLAG_URL+_name+'.png';

            if(_countryCode == conty.sortname){
                _conLang = conty.sortname;
                _conFlag = _imgPath;
                _conName=conty.name;
                _conPh=conty.phonecode;
                _conId=conty.id;
            }
        });
    
        if(this.state.ownerCountryCode.length > 2){
            _conPh = this.state.ownerCountryCode;
        }
        this.setState({countryArray:countryData.response,_countryId:_conId,_countryLang:_conLang,_countryFlag:_conFlag,_countryName:_conName,_countryPh:_conPh,isLoaded:true});
    }


    selectCounties(code,flag,name,e){
        
        this.setState({
            _countryReg:'iti__hide',
            _countryFlag:flag,
            _countryName:name,
            _countryPh:code,
        })
    }

    getReadyMobileCode(){
        let data = [];
        if(this.state.isLoaded == true)
        {
            data = this.state.countryArray.map((conty, i) =>{
                let _name = conty.sortname.toLowerCase();
                let _imgPath = global.FLAG_URL+_name+'.png';
                let _phonecode = conty.phonecode;
                return(
                    <li key={i} className="iti__country iti__standard" id="iti-item-in" onClick={this.selectCounties.bind(this,conty.phonecode,_imgPath,conty.sortname,conty.id)}>
                        <div className="iti__flag-box">
                            <div className="iti__flag" id="itiFlagImg"><img src={_imgPath} /></div>
                        </div>
                        <span className="iti__country-name">{conty.sortname}</span>
                        <span className="iti__dial-code">{_phonecode}</span>
                    </li>
                )
            });
        }
        return data;
    }
    manageMultiCounties(key){
        if(key == 'I'){
            this.setState({_countryReg:''});
        }
        else if(key == 'O'){
            this.setState({_countryReg_O:''});
        }
    }

    onMouseLeaveHandler(key) {
        if(key == 'I'){
            this.setState({_countryReg:'iti__hide'});
        }
        else if(key == 'O'){
            this.setState({_countryReg_O:'iti__hide'});
        }
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        this.setState({isDisabled:false});
        switch (name) {
            case 'loginName': 
                errors.loginName = value.length < 3 ? '*Name must be 3 characters long!' : '';
                this.setState({loginName:value}); 
            break;
            case 'loginEmail': 
                if (validator.isEmail(value)) {
                    errors.loginEmail = '';
                } else {
                    errors.loginEmail = '*Please enter valid email-id.';
                }   
                //errors.loginEmail = value.length < 3 ? '*Enter Valid Email Id!' : '';
                this.setState({loginEmail:value}); 
            break;
            case 'ownerName': 
                errors.ownerName = 
                value.length < 3 ? '*Owner Name must be 3 characters long!' : '';
                if (!value.match(/^[a-zA-Z ]*$/)) {
                    errors.ownerName = "*Please enter alphabet characters only.";
                }
                this.setState({ownerName:value}); 
            break;
            case 'ownerBussAddress': 
                errors.ownerBussAddress = 
                value.length < 3 ? '*Address must be 3 characters long!' : '';
                this.setState({ownerBussAddress:value}); 
            break;
            
            case 'ownerContact': 
                if (validator.isInt(value)) {
                    errors.ownerContact = '';
                } else {
                    errors.ownerContact = '*Please enter valid owner mobile no.';
                } 
                this.setState({ownerContact:value}); 
            break;
            case 'ownerEmail': 
                if (validator.isEmail(value)) {
                    errors.ownerEmail = '';
                } else {
                    errors.ownerEmail = '*Please enter valid owner email-id.';
                }
                this.setState({ownerEmail:value}); 
            break;

            default:
            break;
        }
    }
    
    handlePasswordChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errorsPassword = this.state.errorsPassword;
        this.setState({isDisabled:false});
        switch (name) {
            

            case 'currentPassword': 
            errorsPassword.currentPassword = value.length < 5 ? '*Old Password must be 5 characters long!' : '';
                this.setState({currentPassword:value}); 
            break;
            case 'newPassword': 
            errorsPassword.newPassword = value.length < 5 ? '*New Password must be 5 characters long!' : '';
                if(this.state.confirmPassword.length > 4 && value.length > 4){
                    errorsPassword.newPassword = value!=this.state.confirmPassword ? '*New password and confirm password are not match!' : '';
                }
                this.setState({newPassword:value}); 
            break;
            case 'confirmPassword': 
            errorsPassword.confirmPassword = value.length < 5 ? '*Confirm Password must be 5 characters long!' : '';
                if(value.length > 4){
                    errorsPassword.confirmPassword = value!=this.state.newPassword ? '*Confirm Password not match!' : '';
                }
                this.setState({confirmPassword:value}); 
            break;
            default:
            break;
        }
    }

    clickToManageProfileInfo = (event) => {
        event.preventDefault();
        let errors = this.state.errors;
        let _isError = false;
        if(this.state.loginName == '')
        {
            _isError = true;
            errors['loginName'] = "*Please Enter Name";
            this.setState({errors: errors});
        }
        if(this.state.loginEmail == '')
        {
            _isError = true;
            errors['loginEmail'] = "*Please Enter Email-Id";
            this.setState({errors: errors});
        }
        
        if(this.state.ownerName == '')
        {
            _isError = true;
            errors['ownerName'] = "*Please Enter Owner Name.";
            this.setState({errors: errors});
        }
        if(this.state.ownerBussAddress == '')
        {
            _isError = true;
            errors['ownerBussAddress'] = "*Please Enter Business Address.";
            this.setState({errors: errors});
        }
        
        if(this.state.ownerContact == '')
        {
            _isError = true;
            errors['ownerContact'] = "*Please Enter Owner Contact No.";
            this.setState({errors: errors});
        }
        if(this.state.ownerContact.length < 8 || this.state.ownerContact.length >12 )
        {
            _isError = true;
            errors['ownerContact'] = "*Please enter valid owner contact no.";
            this.setState({errors: errors});
        }
        if(this.state.ownerEmail == '')
        {
            _isError = true;
            errors['ownerEmail'] = "*Please Enter Owner Email.";
            this.setState({errors: errors});
        }

        if(_isError == false)
        {
            let _apiUrl = global.userProfileUpdate;
            if(_loginType == 'Business'){
                _apiUrl = global.businessProfileUpdate;
            }
            let requestData = '' ;
            if(_loginType == 'Business'){
                    requestData = JSON.stringify({
                    loginName: this.state.loginName,
                    emailId :this.state.loginEmail,
                    ownerName :this.state.ownerName,
                    ownerEmail :this.state.ownerEmail,
                    ownerContact :this.state.ownerContact,
                    ownerCountryCode :this.state._countryPh,
                    ownerBussAddress :this.state.ownerBussAddress,
                    loginId: _adminId,
                    loginType: 'Admin',
                });
            }
            if(_loginType!='Business'){
                 requestData = JSON.stringify({
                    loginName: this.state.loginName,
                    emailId :this.state.loginEmail,
                    loginId: _adminId,
                    loginType: 'Admin',
                });
            }
    
            PostData(_apiUrl, requestData,'POST').then((result) => {
                if(result.success == true)
                {
                    sendNotification("Success Message 👍",result.message,"success");
                    // setTimeout(
                    //     () => {
                    //         window.location.href = global.webUrl+'business/dashboard/';
                    //     }, 
                    //     Math.floor(Math.random() * 5000) + 1
                    // )

                    let _updateLocal = vsSession;
                    _updateLocal.loginEmail = this.state.loginEmail;
                    _updateLocal.loginName = this.state.loginName;

                    _updateLocal.owner_name = this.state.ownerName;
                    _updateLocal.owner_email = this.state.ownerEmail;
                    _updateLocal.owner_country_code = this.state._countryPh;
                    _updateLocal.owner_contact = this.state.ownerContact;
                    _updateLocal.business_address = this.state.ownerBussAddress;
                    localStorage.removeItem('vs_UserSession');
                    localStorage.setItem('vs_UserSession', JSON.stringify(_updateLocal));
                    this.setState({reChangeComapny:true});
                    window.location.href = global.webUrl+'business/dashboard/';
                }
                else
                {
                    sendNotification("Error Message 😓",result.message,"danger");
                    let errors = this.state.errors;
                    errors['loginName'] = result.message;//'Please enter valid phone no.';
                    this.setState({
                        errors:errors
                    })
                    return;
                }
            });
        }
    }

    clickToManageProfilePassword = (event) => {
        event.preventDefault();
        let errorsPassword = this.state.errorsPassword;
        let _isError = false;
        if(this.state.currentPassword == '')
        {
            _isError = true;
            errorsPassword['currentPassword'] = "*Please Enter Old Password.";
            this.setState({errorsPassword: errorsPassword});
        }
        if(this.state.newPassword == '')
        {
            _isError = true;
            errorsPassword['newPassword'] = "*Please Enter New Password.";
            this.setState({errorsPassword: errorsPassword});
        }
        if(this.state.confirmPassword == '')
        {
            _isError = true;
            errorsPassword['confirmPassword'] = "*Please Enter Confirm Password.";
            this.setState({errorsPassword: errorsPassword});
        }

        if(_isError == false)
        {
            let _apiUrl = global.userPasswordUpdate;
            if(_loginType == 'Business'){
                _apiUrl = global.businessPasswordUpdate;
            }
            
            const requestData = JSON.stringify({
                newPassword :this.state.newPassword,
                currentPassword :this.state.currentPassword,
                loginId: _adminId,
                loginType: _loginType,
            });
    
            PostData(_apiUrl,requestData,'POST').then((result) => {
                if(result.success == true)
                {
                    sendNotification("Success Message 👍",result.message,"success");
                    setTimeout(
                        () => {
                            window.location.href = global.webUrl+"login/";
                        }, 
                        Math.floor(Math.random() * 5000) + 1
                    )
                }
                else
                {
                    sendNotification("Error Message 😓",result.message,"danger");
                    let errors = this.state.errors;
                    errors['currentPassword'] = "Please enter correct current password";//'Please enter valid phone no.';
                    this.setState({
                        errors:errors
                    })
                    return;
                }
            });
        }
    }

    onAvatarClick = () => {
        if (this.state.uploadingPic) return;
        if (this.fileInputRef) this.fileInputRef.click();
    }

    handleProfilePicFile = (file) => {
        if (!file) return;
        if (!/^image\//.test(file.type)) {
            sendNotification("Error Message 😓", "Please choose an image file (JPG, PNG, or GIF)", "danger");
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            sendNotification("Error Message 😓", "Image must be smaller than 5 MB", "danger");
            return;
        }

        // Optimistic preview via local data URL — the user sees their new avatar
        // instantly while the upload runs.
        const reader = new FileReader();
        reader.onload = (e) => {
            this.setState({ previewUrl: e.target.result });
        };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append('profilePic', file);
        formData.append('loginId', _adminId);
        formData.append('loginType', _loginType);

        this.setState({ uploadingPic: true, uploadProgress: 0 });
        axios({
            method: 'post',
            url: global.businessProfilePicUpdate,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (evt) => {
                if (evt.total) {
                    const pct = Math.round((evt.loaded / evt.total) * 100);
                    this.setState({ uploadProgress: pct });
                }
            },
        }).then((res) => {
            const result = res.data;
            if (result && result.success) {
                sendNotification("Success Message 👍", result.message, "success");
                const newUrl = result.profile_logo + '?t=' + Date.now();
                this.setState({
                    profileLogo: newUrl,
                    previewUrl: '',
                    avatarBroken: false,
                    uploadingPic: false,
                    uploadProgress: 0,
                });
                try {
                    const updated = { ...(vsSession || {}), profile_logo: result.profile_logo };
                    localStorage.setItem('vs_UserSession', JSON.stringify(updated));
                } catch (e) { /* ignore storage errors */ }
            } else {
                sendNotification("Error Message 😓", (result && result.message) || "Upload failed", "danger");
                this.setState({ uploadingPic: false, previewUrl: '', uploadProgress: 0 });
            }
        }).catch(() => {
            sendNotification("Error Message 😓", "Upload failed. Please try again.", "danger");
            this.setState({ uploadingPic: false, previewUrl: '', uploadProgress: 0 });
        });
    }

    onProfilePicSelect = (event) => {
        const file = event.target.files && event.target.files[0];
        this.handleProfilePicFile(file);
        // Reset so the same file can be re-picked if the user retries.
        event.target.value = '';
    }

    onAvatarDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.state.isDraggingFile) this.setState({ isDraggingFile: true });
    }
    onAvatarDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDraggingFile: false });
    }
    onAvatarDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDraggingFile: false });
        const file = e.dataTransfer.files && e.dataTransfer.files[0];
        this.handleProfilePicFile(file);
    }

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }

        const {errors} = this.state;
        const {errorsPassword} = this.state;
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        const isDisabledPass = Object.keys(errorsPassword).some(x => errorsPassword[x]);
        let textTitle = "Manage Business Profile";
        let businessName = "Business Name";
        let businessEmail = "Business Email Id";
        let subtitleText = "Update your business details, contact info, and password.";
        if(this.state.loginType == 'BusinessUser'){
            textTitle = "Manage Business User Profile";
            businessName = "Business User Name";
            businessEmail = "Business User Email Id";
            subtitleText = "Update your account details and password.";
        }

        // Modern design tokens (inline so we don't touch global CSS).
        const S = {
            page: { padding: "16px 24px", background: "#f5f7fb", minHeight: "100vh" },
            header: {
                background: "linear-gradient(135deg, #4f46e5 0%, #6366f1 60%, #8b5cf6 100%)",
                borderRadius: "16px",
                padding: "28px 32px",
                color: "#fff",
                marginBottom: "24px",
                boxShadow: "0 10px 30px rgba(79, 70, 229, 0.25)",
            },
            headerTitle: { fontSize: "22px", fontWeight: 700, margin: 0, letterSpacing: "0.2px" },
            headerSubtitle: { marginTop: "6px", opacity: 0.85, fontSize: "13px" },
            breadcrumb: { marginBottom: "20px", fontSize: "13px", color: "#6b7280" },
            breadcrumbLink: { color: "#4f46e5", textDecoration: "none", fontWeight: 500 },
            grid: { display: "grid", gridTemplateColumns: "320px 1fr", gap: "20px", alignItems: "start" },
            sideCard: {
                background: "#fff",
                borderRadius: "14px",
                padding: "28px 20px",
                boxShadow: "0 4px 16px rgba(17, 24, 39, 0.06)",
                textAlign: "center",
                border: "1px solid #eef0f5",
            },
            avatarWrap: {
                width: "96px", height: "96px", borderRadius: "50%",
                margin: "0 auto 14px",
                background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontSize: "36px", fontWeight: 700,
                boxShadow: "0 6px 18px rgba(99, 102, 241, 0.35)",
                overflow: "hidden",
            },
            avatarImg: { width: "100%", height: "100%", objectFit: "cover" },
            sideName: { fontSize: "16px", fontWeight: 600, color: "#111827", margin: "6px 0 2px" },
            sideEmail: { fontSize: "12px", color: "#6b7280", wordBreak: "break-all" },
            badge: {
                display: "inline-block", padding: "3px 10px", marginTop: "10px",
                background: "#eef2ff", color: "#4338ca",
                fontSize: "11px", fontWeight: 600, borderRadius: "999px", letterSpacing: "0.3px",
            },
            infoRow: {
                marginTop: "18px", padding: "12px 14px",
                background: "#f9fafb", borderRadius: "10px",
                display: "flex", alignItems: "center", gap: "10px", textAlign: "left",
            },
            infoIcon: { width: "32px", height: "32px", borderRadius: "8px", background: "#eef2ff", color: "#4f46e5",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
            infoLabel: { fontSize: "11px", color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.3px" },
            infoValue: { fontSize: "13px", color: "#111827", fontWeight: 500, marginTop: "2px", wordBreak: "break-all" },
            card: {
                background: "#fff", borderRadius: "14px", marginBottom: "20px",
                boxShadow: "0 4px 16px rgba(17, 24, 39, 0.06)", border: "1px solid #eef0f5",
                overflow: "hidden",
            },
            cardHead: {
                padding: "18px 24px", borderBottom: "1px solid #f1f2f6",
                display: "flex", alignItems: "center", gap: "12px",
            },
            cardHeadIcon: {
                width: "38px", height: "38px", borderRadius: "10px",
                background: "linear-gradient(135deg, #4f46e5, #6366f1)", color: "#fff",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px",
            },
            cardTitle: { fontSize: "15px", fontWeight: 600, color: "#111827", margin: 0 },
            cardSub: { fontSize: "12px", color: "#6b7280", marginTop: "2px" },
            cardBody: { padding: "24px" },
            fieldRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px", marginBottom: "14px" },
            fieldRowSingle: { marginBottom: "14px" },
            label: { display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "6px" },
            required: { color: "#ef4444", marginLeft: "3px" },
            input: {
                width: "100%", padding: "11px 14px", fontSize: "14px",
                border: "1px solid #e5e7eb", borderRadius: "10px", background: "#fff",
                color: "#111827", outline: "none", transition: "border-color .15s, box-shadow .15s",
                boxSizing: "border-box",
            },
            inputError: { borderColor: "#ef4444" },
            errorText: { color: "#ef4444", fontSize: "12px", marginTop: "6px", display: "block" },
            phoneWrap: {
                display: "flex", alignItems: "stretch", border: "1px solid #e5e7eb",
                borderRadius: "10px", overflow: "visible", background: "#fff", position: "relative",
            },
            phoneCode: {
                padding: "10px 14px", background: "#f9fafb",
                borderRight: "1px solid #e5e7eb", display: "flex", alignItems: "center", gap: "6px",
                cursor: "pointer", fontSize: "13px", color: "#374151", fontWeight: 500,
                minWidth: "88px",
            },
            phoneInput: {
                flex: 1, padding: "11px 14px", fontSize: "14px",
                border: "none", outline: "none", background: "transparent",
            },
            btn: {
                padding: "11px 22px", fontSize: "14px", fontWeight: 600,
                borderRadius: "10px", border: "none", cursor: "pointer",
                background: "linear-gradient(135deg, #4f46e5, #6366f1)", color: "#fff",
                boxShadow: "0 6px 14px rgba(79, 70, 229, 0.30)",
                transition: "transform .1s, box-shadow .15s, opacity .15s",
            },
            btnDisabled: { opacity: 0.55, cursor: "not-allowed", boxShadow: "none" },
            btnRow: { marginTop: "8px", display: "flex", justifyContent: "flex-end", gap: "10px" },
        };

        const initial = (this.state.loginName || "U").trim().charAt(0).toUpperCase();
        const showBusinessFields = this.state.loginType != 'BusinessUser';

        return(
            <React.Fragment>
                <div style={S.page}>
                    {/* Hero header */}
                    <div style={S.header}>
                        <h1 style={S.headerTitle}>
                            <i className="fa fa-id-card-o mr-10" style={{opacity:.9}}></i>{textTitle}
                        </h1>
                        <div style={S.headerSubtitle}>{subtitleText}</div>
                    </div>

                    {/* Breadcrumb */}
                    <div style={S.breadcrumb}>
                        <a style={S.breadcrumbLink} href={global.webUrl+"administrator/dashboard/"}>Dashboard</a>
                        <span style={{margin:"0 8px"}}>›</span>
                        <span>{textTitle}</span>
                    </div>

                    {/* Content grid */}
                    <div style={S.grid} className="vs-profile-grid">
                        {/* Left: profile summary */}
                        <div style={S.sideCard}>
                            {(() => {
                                const showImage =
                                    (this.state.previewUrl && this.state.previewUrl.length > 0) ||
                                    (this.state.profileLogo && !this.state.avatarBroken);
                                const imgSrc = this.state.previewUrl || this.state.profileLogo;
                                const uploading = this.state.uploadingPic;
                                const hovering = this.state.isAvatarHover;
                                const dragging = this.state.isDraggingFile;
                                return (
                                    <div
                                        onClick={this.onAvatarClick}
                                        onMouseEnter={() => this.setState({ isAvatarHover: true })}
                                        onMouseLeave={() => this.setState({ isAvatarHover: false })}
                                        onDragOver={this.onAvatarDragOver}
                                        onDragLeave={this.onAvatarDragLeave}
                                        onDrop={this.onAvatarDrop}
                                        title="Click or drop an image to change"
                                        style={{
                                            ...S.avatarWrap,
                                            position: "relative",
                                            cursor: uploading ? "wait" : "pointer",
                                            transition: "transform .18s ease, box-shadow .18s ease",
                                            transform: hovering && !uploading ? "scale(1.03)" : "scale(1)",
                                            boxShadow: dragging
                                                ? "0 0 0 4px rgba(99,102,241,0.35), 0 6px 18px rgba(99,102,241,0.35)"
                                                : "0 6px 18px rgba(99, 102, 241, 0.35)",
                                            outline: dragging ? "2px dashed #6366f1" : "none",
                                            outlineOffset: "4px",
                                        }}
                                    >
                                        {showImage
                                            ? <img
                                                src={imgSrc}
                                                alt=""
                                                style={S.avatarImg}
                                                onError={() => this.setState({ avatarBroken: true })}
                                              />
                                            : <span>{initial}</span>}

                                        {/* Hover overlay */}
                                        {hovering && !uploading && (
                                            <div style={{
                                                position:"absolute", inset:0, borderRadius:"50%",
                                                background:"rgba(17,24,39,0.55)", color:"#fff",
                                                display:"flex", flexDirection:"column",
                                                alignItems:"center", justifyContent:"center",
                                                fontSize:"11px", fontWeight:600, letterSpacing:"0.3px",
                                                transition:"opacity .15s",
                                            }}>
                                                <i className="fa fa-camera" style={{fontSize:"22px", marginBottom:"4px"}}></i>
                                                CHANGE PHOTO
                                            </div>
                                        )}

                                        {/* Upload progress overlay */}
                                        {uploading && (
                                            <div style={{
                                                position:"absolute", inset:0, borderRadius:"50%",
                                                background:"rgba(17,24,39,0.62)", color:"#fff",
                                                display:"flex", flexDirection:"column",
                                                alignItems:"center", justifyContent:"center",
                                                fontSize:"13px", fontWeight:700,
                                            }}>
                                                {this.state.uploadProgress}%
                                                <div style={{
                                                    marginTop:"6px", width:"60px", height:"4px",
                                                    background:"rgba(255,255,255,0.25)", borderRadius:"2px",
                                                    overflow:"hidden",
                                                }}>
                                                    <div style={{
                                                        width: this.state.uploadProgress + "%",
                                                        height:"100%", background:"#fff",
                                                        transition:"width .15s linear",
                                                    }}/>
                                                </div>
                                            </div>
                                        )}

                                        {/* Persistent camera badge */}
                                        <div style={{
                                            position:"absolute", right:"2px", bottom:"2px",
                                            width:"30px", height:"30px", borderRadius:"50%",
                                            background:"#111827", color:"#fff",
                                            display:"flex", alignItems:"center", justifyContent:"center",
                                            border:"3px solid #fff", boxShadow:"0 4px 10px rgba(0,0,0,0.2)",
                                            fontSize:"12px",
                                        }}>
                                            <i className="fa fa-camera"></i>
                                        </div>
                                    </div>
                                );
                            })()}
                            <input
                                type="file"
                                accept="image/*"
                                ref={(r) => { this.fileInputRef = r; }}
                                onChange={this.onProfilePicSelect}
                                style={{ display: "none" }}
                            />
                            <div style={{fontSize:"11px", color:"#9ca3af", marginTop:"10px"}}>
                                Click or drag an image • JPG / PNG / GIF up to 5 MB
                            </div>
                            <div style={{...S.sideName, marginTop:"14px"}}>{this.state.loginName || 'Business User'}</div>
                            <div style={S.sideEmail}>{this.state.loginEmail}</div>
                            <div style={S.badge}>{this.state.loginType}</div>

                            {showBusinessFields && this.state.ownerName && (
                                <div style={S.infoRow}>
                                    <div style={S.infoIcon}><i className="fa fa-user"></i></div>
                                    <div>
                                        <div style={S.infoLabel}>Owner</div>
                                        <div style={S.infoValue}>{this.state.ownerName}</div>
                                    </div>
                                </div>
                            )}
                            {showBusinessFields && this.state.ownerContact && (
                                <div style={S.infoRow}>
                                    <div style={S.infoIcon}><i className="fa fa-phone"></i></div>
                                    <div>
                                        <div style={S.infoLabel}>Contact</div>
                                        <div style={S.infoValue}>{this.state._countryPh} {this.state.ownerContact}</div>
                                    </div>
                                </div>
                            )}
                            {showBusinessFields && this.state.ownerBussAddress && (
                                <div style={S.infoRow}>
                                    <div style={S.infoIcon}><i className="fa fa-map-marker"></i></div>
                                    <div>
                                        <div style={S.infoLabel}>Address</div>
                                        <div style={S.infoValue}>{this.state.ownerBussAddress}</div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Right: forms */}
                        <div>
                            {/* Profile Information */}
                            <div style={S.card}>
                                <div style={S.cardHead}>
                                    <div style={S.cardHeadIcon}><i className="fa fa-user-circle"></i></div>
                                    <div>
                                        <h3 style={S.cardTitle}>Profile Information</h3>
                                        <div style={S.cardSub}>Vital account details. Your name will be publicly visible.</div>
                                    </div>
                                </div>
                                <div style={S.cardBody}>
                                    <div style={showBusinessFields ? S.fieldRow : S.fieldRowSingle}>
                                        <div>
                                            <label style={S.label} htmlFor="loginName">
                                                {businessName}<span style={S.required}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="loginName" name="loginName"
                                                onChange={this.handleChange}
                                                placeholder="Enter your name.."
                                                value={this.state.loginName}
                                                style={{...S.input, ...(errors.loginName ? S.inputError : {})}}
                                            />
                                            {errors.loginName.length > 0 && <span style={S.errorText}>{errors.loginName}</span>}
                                        </div>
                                        {showBusinessFields && (
                                            <div>
                                                <label style={S.label} htmlFor="loginEmail">
                                                    {businessEmail}<span style={S.required}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="loginEmail" name="loginEmail"
                                                    onChange={this.handleChange}
                                                    placeholder="Enter your email id.."
                                                    value={this.state.loginEmail}
                                                    style={{...S.input, ...(errors.loginEmail ? S.inputError : {})}}
                                                />
                                                {errors.loginEmail.length > 0 && <span style={S.errorText}>{errors.loginEmail}</span>}
                                            </div>
                                        )}
                                    </div>

                                    {showBusinessFields && (
                                        <div id='ownerDetail'>
                                            <div style={S.fieldRow}>
                                                <div>
                                                    <label style={S.label} htmlFor="ownerName">Owner Name<span style={S.required}>*</span></label>
                                                    <input
                                                        type="text"
                                                        id="ownerName" name="ownerName"
                                                        onChange={this.handleChange}
                                                        placeholder="Enter your owner name"
                                                        value={this.state.ownerName}
                                                        style={{...S.input, ...(errors.ownerName ? S.inputError : {})}}
                                                    />
                                                    {errors.ownerName.length > 0 && <span style={S.errorText}>{errors.ownerName}</span>}
                                                </div>
                                                <div>
                                                    <label style={S.label} htmlFor="ownerEmail">Owner Email<span style={S.required}>*</span></label>
                                                    <input
                                                        type="text"
                                                        id="ownerEmail" name="ownerEmail"
                                                        onChange={this.handleChange}
                                                        placeholder="Enter your owner email id"
                                                        value={this.state.ownerEmail}
                                                        style={{...S.input, ...(errors.ownerEmail ? S.inputError : {})}}
                                                    />
                                                    {errors.ownerEmail.length > 0 && <span style={S.errorText}>{errors.ownerEmail}</span>}
                                                </div>
                                            </div>

                                            <div style={S.fieldRow}>
                                                <div>
                                                    <label style={S.label} htmlFor="ownerContact">Owner Contact No<span style={S.required}>*</span></label>
                                                    <div
                                                        style={S.phoneWrap}
                                                        onMouseEnter={this.manageMultiCounties.bind(this,'I')}
                                                        onMouseLeave={this.onMouseLeaveHandler.bind(this,'I')}
                                                    >
                                                        <div className="iti__flag-container" style={{position:"static", borderBottom: 0}}>
                                                            <div style={S.phoneCode} className="iti__selected-flag" title={this.state._countryName}>
                                                                <span>{this.state._countryPh}</span>
                                                                <i className="si si-arrow-down" style={{fontSize:"10px", opacity:.6}}></i>
                                                            </div>
                                                            <ul
                                                                className={this.state._countryReg +" iti__country-list iti__country-list--dropup"}
                                                                id="country-listbox"
                                                                aria-expanded="false"
                                                                role="listbox"
                                                                aria-activedescendant="iti-item-ad"
                                                            >
                                                                {this.getReadyMobileCode()}
                                                            </ul>
                                                        </div>
                                                        <input
                                                            type="number"
                                                            id="ownerContact" name="ownerContact"
                                                            onChange={this.handleChange}
                                                            placeholder="Enter Owner Contact No"
                                                            value={this.state.ownerContact}
                                                            maxLength="12"
                                                            autoComplete='off'
                                                            style={S.phoneInput}
                                                        />
                                                    </div>
                                                    {errors.ownerContact.length > 0 && <span style={S.errorText}>{errors.ownerContact}</span>}
                                                </div>
                                                <div>
                                                    <label style={S.label} htmlFor="ownerBussAddress">Business Address<span style={S.required}>*</span></label>
                                                    <input
                                                        type="text"
                                                        id="ownerBussAddress" name="ownerBussAddress"
                                                        onChange={this.handleChange}
                                                        placeholder="Enter your business address"
                                                        value={this.state.ownerBussAddress}
                                                        style={{...S.input, ...(errors.ownerBussAddress ? S.inputError : {})}}
                                                    />
                                                    {errors.ownerBussAddress.length > 0 && <span style={S.errorText}>{errors.ownerBussAddress}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div style={S.btnRow}>
                                        <button
                                            type="submit"
                                            disabled={isDisabled}
                                            style={{...S.btn, ...(isDisabled ? S.btnDisabled : {})}}
                                            onClick={this.clickToManageProfileInfo}
                                        >
                                            <i className="fa fa-check mr-5"></i> Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Change Password */}
                            <div style={S.card}>
                                <div style={S.cardHead}>
                                    <div style={{...S.cardHeadIcon, background:"linear-gradient(135deg, #ef4444, #f97316)"}}>
                                        <i className="fa fa-lock"></i>
                                    </div>
                                    <div>
                                        <h3 style={S.cardTitle}>Change Password</h3>
                                        <div style={S.cardSub}>Rotate your sign-in password regularly to keep your account safe.</div>
                                    </div>
                                </div>
                                <div style={S.cardBody}>
                                    <div style={S.fieldRowSingle}>
                                        <label style={S.label} htmlFor="currentPassword">Current Password<span style={S.required}>*</span></label>
                                        <input
                                            type="password"
                                            id="currentPassword" name="currentPassword"
                                            onChange={this.handlePasswordChange}
                                            style={{...S.input, ...(errorsPassword.currentPassword ? S.inputError : {})}}
                                        />
                                        {errorsPassword.currentPassword.length > 0 && <span style={S.errorText}>{errorsPassword.currentPassword}</span>}
                                    </div>
                                    <div style={S.fieldRow}>
                                        <div>
                                            <label style={S.label} htmlFor="newPassword">New Password<span style={S.required}>*</span></label>
                                            <input
                                                type="password"
                                                id="newPassword" name="newPassword"
                                                onChange={this.handlePasswordChange}
                                                style={{...S.input, ...(errorsPassword.newPassword ? S.inputError : {})}}
                                            />
                                            {errorsPassword.newPassword.length > 0 && <span style={S.errorText}>{errorsPassword.newPassword}</span>}
                                        </div>
                                        <div>
                                            <label style={S.label} htmlFor="confirmPassword">Confirm New Password<span style={S.required}>*</span></label>
                                            <input
                                                type="password"
                                                id="confirmPassword" name="confirmPassword"
                                                onChange={this.handlePasswordChange}
                                                style={{...S.input, ...(errorsPassword.confirmPassword ? S.inputError : {})}}
                                            />
                                            {errorsPassword.confirmPassword.length > 0 && <span style={S.errorText}>{errorsPassword.confirmPassword}</span>}
                                        </div>
                                    </div>
                                    <div style={S.btnRow}>
                                        <button
                                            type="submit"
                                            disabled={isDisabledPass}
                                            style={{...S.btn, background:"linear-gradient(135deg, #ef4444, #f97316)", boxShadow:"0 6px 14px rgba(239,68,68,0.30)", ...(isDisabledPass ? S.btnDisabled : {})}}
                                            onClick={this.clickToManageProfilePassword}
                                        >
                                            <i className="fa fa-shield mr-5"></i> Update Password
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive fallback for narrow screens: stack side card on top */}
                <style>{`
                    @media (max-width: 900px) {
                        .vs-profile-grid { grid-template-columns: 1fr !important; }
                    }
                `}</style>

                <div id="global_loader" className={_loader}>
                    <div className="gl-ldr-cld">
                        <div className="gl-ldr-ctr">
                            <div className="gl-loader"></div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}